import { formatISO } from 'date-fns';

import { HistoryDatepickerWithModal } from 'reusable/historyDatepickerWithModal/HistoryDatepickerWithModal';
import { TableSearchContainer } from 'reusable/tableSearch/TableSearchContainer';
import { HistoryActionAutocomplete } from 'reusable/historyActionAutocomplete/HistoryActionAutocomplete';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { UserHistoryQuery } from 'context/query/queryContext/QueryContext.types';
import { QueryKeyLocalStorageEnum } from 'context/query/queryContext/QueryContext.enum';

import { UserDetailsHistoryFiltersProps } from './UserHistoryFilters.types';

export const UserDetailsHistoryFilters = ({ userSearchQuery, setUserSearchQuery }: UserDetailsHistoryFiltersProps) => {
  const { formatMessage } = useLocale();

  const {
    storedQueries: { userHistory: userHistoryQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const setHistoryQuery = (query: UserHistoryQuery) => {
    setQuery(QueryKeyLocalStorageEnum.USER_HISTORY, { ...userHistoryQuery, ...query });
  };

  return (
    <>
      <HistoryDatepickerWithModal
        dates={[
          userHistoryQuery.dataOd ? new Date(userHistoryQuery.dataOd) : null,
          userHistoryQuery.dataDo ? new Date(userHistoryQuery.dataDo) : null,
        ]}
        setDates={(dates) =>
          setHistoryQuery({
            dataOd: dates[0] ? formatISO(dates[0]) : undefined,
            dataDo: dates[1] ? formatISO(dates[1]) : undefined,
          })
        }
      />

      <HistoryActionAutocomplete
        selectedAction={userHistoryQuery.akcja}
        onChangeAction={(action) => setHistoryQuery({ akcja: action })}
        historyType="user"
      />

      <TableSearchContainer
        withoutToggle
        inputPlaceholder={formatMessage({ id: AppMessages['user.history.searchPlaceholder'] })}
        searchBy="users"
        tableSearchQuery={userSearchQuery}
        setTableSearchQuery={setUserSearchQuery}
        selectedValue={userHistoryQuery.query}
        setSelectedValue={(option) => setHistoryQuery({ query: option || undefined })}
        inputSize="big"
      />
    </>
  );
};
